export default "__VITE_PUBLIC_ASSET__1499d304__"